import Component from 'navigation/component/Component';
import { updatePageLinks } from 'core/router';
import { dimensions } from 'helpers/resize';
import math from 'helpers/math';
class InfiniteLine extends Component {
    items;
    originalItems;
    originalSize = 0;
    clonedItems = [];
    itemSizes = [];
    vertical = false;
    totalSize = 0;
    screenSize = 0;
    _offset = 0;
    total;
    constructor(el, { vertical = false } = {}) {
        super(el);
        this.vertical = vertical;
        this.el.classList.add('infinite-line');
        if (vertical)
            this.el.classList.add('infinite-line--vertical');
        this.originalItems = Array.from(this.el.children);
        this.items = Array.from(this.el.children);
        this.total = this.items.length;
        this.resize();
        this.onUpdate();
    }
    set offset(value) {
        if (isNaN(value))
            return;
        this._offset = value % this.totalSize;
        this.onUpdate();
    }
    get offset() {
        return this._offset;
    }
    get itemSize() {
        return this.itemSizes;
    }
    onUpdate = () => {
        let inc = 0;
        const current = this.offset;
        this.items.forEach((item, index) => {
            const size = this.itemSizes[index];
            const offset = math.wrap(current + inc, -size, this.totalSize - size);
            const isVisible = (offset + size) > 0 && offset < this.screenSize;
            if (isVisible) {
                item.style.transform = this.vertical ? `translate3d(0,${offset}px,0)` : `translate3d(${offset}px,0,0)`;
                item.style.visibility = 'inherit';
            }
            else {
                item.style.visibility = 'hidden';
            }
            inc += size;
        });
    };
    resize() {
        super.resize();
        this.itemSizes = this.items?.map(item => {
            const bbox = item.getBoundingClientRect();
            return this.vertical ? bbox.height : bbox.width;
        });
        const multiplier = this.items.length / this.originalItems.length;
        this.totalSize = this.itemSizes.reduce((acc, size) => acc + size, 0);
        this.originalSize = this.totalSize / multiplier;
        this.el.style.setProperty('--total-size', `${this.totalSize}px`);
        this.screenSize = this.vertical ? dimensions().height : dimensions().width;
        this.restructure();
        this.el.style.setProperty('--screen-size', `${this.screenSize}px`);
        this.el.style.setProperty('--min-size', `${this.getMinSize()}px`);
    }
    getMinSize = () => {
        const maxItem = this.itemSizes.reduce((acc, item) => Math.max(acc, item), -1);
        return this.totalSize - maxItem;
    };
    restructure() {
        if (!this.items?.length)
            return;
        let restructure = false;
        while (this.getMinSize() < this.screenSize && this.items.length < 50) {
            // const inc = this.items.length
            // const id = inc % this.originalItems.length
            // const clone = this.originalItems[id].cloneNode(true) as HTMLElement
            // this.el.appendChild(clone)
            // this.items.push(clone)
            // this.totalSize += this.vertical ? clone.offsetHeight : clone.offsetWidth
            this.originalItems.forEach((item) => {
                const clone = item.cloneNode(true);
                clone.classList.add('infinite-line__clone');
                this.el.appendChild(clone);
                this.items.push(clone);
                this.clonedItems.push(clone);
                this.totalSize += this.vertical ? clone.offsetHeight : clone.offsetWidth;
            });
            restructure = true;
        }
        if (restructure) {
            this.resize();
            updatePageLinks();
            this.emit('restructure');
        }
    }
    reset = () => {
        this.resize();
        this.restructure();
        this.onUpdate();
        this.offset = 0;
    };
    disable = () => {
        this.el.classList.remove('infinite-line');
        this.reset();
        this.items.forEach((item, index) => {
            item.style.transform = '';
            item.style.visibility = '';
        });
    };
    enable = () => {
        this.el.classList.add('infinite-line');
        this.resize();
        this.restructure();
        this.onUpdate();
    };
    flush() {
        this.disable();
        this.clonedItems.forEach((item) => item.remove());
        super.flush();
    }
}
export default InfiniteLine;
